import type { AppearanceStyle } from '@tribeplatform/design-system/types'

import { NetworkColorScheme, UserColorScheme } from './types.js'

export const DEFAULT_STYLE: AppearanceStyle = {
  corners: 'round',
  cards: 'elevated',
  buttons: 'rounded',
  avatars: 'initials',
  avatarShape: 'full-rounded',
}

export const DEFAULT_NETWORK_COLOR_SCHEME: NetworkColorScheme = {
  mode: 'user-preference',
  light: 'light1',
  dark: 'dark1',
}
export const LEGACY_NETWORK_COLOR_SCHEME: NetworkColorScheme = {
  mode: 'single',
  default: 'light1',
}

export const DEFAULT_USER_COLOR_SCHEME: UserColorScheme = 'auto'

export const TYPOGRAPHY_LINK_ID = 'font'
export const TYPOGRAPHY_STYLE_ID = 'typography'

export const THEME_STYLE_ID = 'theme'
